<div class="container">
  <h4 class="title">{{ form.companyDetails.companyName }} Privacy Notice for California Residents</h4>
  <p>
    Effective Date: September 1, {{currentyear | date:'yyyy' }}
    <br>
    Last Revised: September 1, {{currentyear | date:'yyyy' }}
    <br>
    <br>
    This privacy notice for California residents supplements the information contained in
    privacy policy
    and applies solely to all visitors, users, and others who reside in the State of California (consumers or you). We adopt this notice to comply with the California Consumer Privacy Act of 2018 (CCPA) and any terms defined in the CCPA have the same meaning when used in this Notice.
  </p>
  <h4 class="title">
    Information We Collect
  </h4>
  <p>
    Our Website collects information that identifies, relates to, describes, references, is reasonably capable of being associated with, or could reasonably be linked, directly or indirectly, with a particular consumer, household, or device (<b>personal information</b>). Personal information does not include:
  </p>
  <ul>
    <li>Publicly available information from government records.</li>
    <li>Deidentified or aggregated consumer information.</li>
    <li>
      Information excluded from the CCPA's scope, like:<br>
      Health or medical information covered by the Health Insurance Portability and Accountability Act of 1996 (HIPAA) and the California Confidentiality of Medical Information Act (CMIA) or clinical trial data; and
      personal information covered by certain sector-specific privacy laws, including the Fair Credit Reporting Act (FCRA), the Gramm-Leach-Bliley Act (GLBA) or California Financial Information Privacy Act(FIPA), and the Driver's Privacy Protection Act of 1994.
    </li>
  </ul>
  <p>
    In particular, our Website has collected the following categories of personal information from its consumers within the last 12 months:
  </p>
  <table border=1 cellspacing=0 cellpadding=0 width="100%"
  style='width:100.0%;border-collapse:collapse;border:none'>
  <tr>
    <td width="20%" valign=top>
      <p align=center style='text-align:center'>Category</p>
    </td>
    <td width="60%" valign=top >
      <p align=center style='text-align:center'>Examples</p>
    </td>
    <td width="20%" valign=top>
      <p align=center style='text-align:center'>Collected</p>
    </td>
  </tr>
  <tr>
    <td width="20%" valign=top>
      <p>A. Identifiers.</p>
    </td>
    <td width="60%" valign=top>
      <p>A real name, alias, postal address, unique personal identifier, online identifier, Internet Protocol address, email address, account name, Social Security number, driver's license number, passport number, or other similar identifiers.</p>
    </td>
    <td width="20%" valign=top>
      <p>YES</p>
    </td>
  </tr>
  <tr>
    <td width="20%" valign=top>
    <p>B.
    Personal information categories listed in the California Customer Records
    statute (Cal. Civ. Code 1798.80(e)).</p>
    </td>
    <td width="60%" valign=top>
    <p>A
    name, signature, Social Security number, physical characteristics or
    description, address, telephone number, passport number, driver's license or
    state identification card number, insurance policy number, education,
    employment, employment history, bank account number, credit card number,
    debit card number, or any other financial information, medical information,
    or health insurance information.</p>
    <p>Some
    personal information included in this category may overlap with other
    categories.</p>
    </td>
    <td width="20%" valign=top>
    <p>YES</p>
    </td>
  </tr>
  <tr>
    <td width="20%" valign=top>
    <p>C.
    Protected classification characteristics under California or federal law.</p>
    </td>
    <td width="60%" valign=top>
    <p>Age
    (40 years or older), race, color, ancestry, national origin, citizenship,
    religion or creed, marital status, medical condition, physical or mental
    disability, sex (including gender, gender identity, gender expression,
    pregnancy or childbirth, and related medical conditions), sexual orientation,
    veteran or military status, genetic information (including familial genetic
    information).</p>
    </td>
    <td width="20%" valign=top>
    <p>NO</p>
    </td>
  </tr>
  <tr>
    <td width="20%" valign=top>
    <p>D.
    Commercial information.</p>
    </td>
    <td width="60%" valign=top>
    <p>Records
    of personal property, products or services purchased, obtained, or
    considered, or other purchasing or consuming histories or tendencies.</p>
    </td>
    <td width="20%" valign=top>
    <p>YES</p>
    </td>
  </tr>
  <tr>
    <td width="20%" valign=top>
    <p>E.
    Biometric information.</p>
    </td>
    <td width="60%" valign=top>
    <p>Genetic,
    physiological, behavioral, and biological characteristics, or activity
    patterns used to extract a template or other identifier or identifying
    information, such as, fingerprints, faceprints, and voiceprints, iris or
    retina scans, keystroke, gait, or other physical patterns, and sleep, health,
    or exercise data.</p>
    </td>
    <td width="20%" valign=top>
    <p>NO</p>
    </td>
  </tr>
  <tr>
    <td width="20%" valign=top>
    <p>F.
    Internet or other similar network activity.</p>
    </td>
    <td width="60%" valign=top>
    <p>Browsing
    history, search history, information on a consumer's interaction with a
    website, application, or advertisement.</p>
    </td>
    <td width="20%" valign=top>
    <p>YES</p>
    </td>
  </tr>
  <tr>
    <td width="20%" valign=top>
    <p>G.
    Geolocation data.</p>
    </td>
    <td width="60%" valign=top>
    <p>Physical
    location or movements.</p>
    </td>
    <td width="20%" valign=top>
    <p>NO</p>
    </td>
  </tr>
  <tr>
    <td width="20%" valign=top>
    <p>H.
    Sensory data.</p>
    </td>
    <td width="60%" valign=top>
    <p>Audio,
    electronic, visual, thermal, olfactory, or similar information.</p>
    </td>
    <td width="20%" valign=top>
    <p>NO</p>
    </td>
  </tr>
  <tr>
    <td width="20%" valign=top>
    <p>I.
    Professional or employment-related information.</p>
    </td>
    <td width="60%" valign=top>
    <p>Current
    or past job history or performance evaluations.</p>
    </td>
    <td width="20%" valign=top>
    <p>NO</p>
    </td>
  </tr>
  <tr>
    <td width="20%" valign=top >
    <p>J.
    Non-public education information (per the Family Educational Rights and
    Privacy Act (20 U.S.C. Section 1232g, 34 C.F.R. Part 99)).</p>
    </td>
    <td width="60%" valign=top>
    <p>Education
    records directly related to a student maintained by an educational
    institution or party acting on its behalf, such as grades, transcripts, class
    lists, student schedules, student identification codes, student financial
    information, or student disciplinary records.</p>
    </td>
    <td width="20%" valign=top>
    <p>NO</p>
    </td>
  </tr>
  <tr>
    <td width="20%" valign=top>
    <p>K.
    Inferences drawn from other personal information.</p>
    </td>
    <td width="60%" valign=top>
    <p>Profile
    reflecting a person's preferences, characteristics, psychological trends,
    predispositions, behavior, attitudes, intelligence, abilities, and aptitudes.</p>
    </td>
    <td width="20%" valign=top>
    <p>NO</p>
    </td>
  </tr>
  </table>

  <p>
    Our Website obtains the categories of personal information listed above from the following categories of sources:
  </p>
  <ul>
    <li>
      Directly from you. For example, from forms you complete or products and services you purchase.
    </li>
    <li>
      Indirectly from you. For example, from observing your actions on our Website.
    </li>
    <li>
      From third parties. For example, from our business partners.
    </li>
  </ul>

  <h5>
    Use of Personal Information
  </h5>
  <p>
    We may use or disclose the personal information we collect for one or more of the following purposes:
  </p>
  <ul>
    <li>
      To fulfill or meet the reason you provided the information. For example, if you share your name and contact information to ask a question about our products or services, we will use that personal information to respond to your inquiry. If you provide your personal information to purchase a product or service, we will use that information to process your payment. We may also save your information to facilitate new orders.
    </li>
    <li>
      To provide, support, personalize, and develop our Website, products, and services.
    </li>
    <li>
      To create, maintain, customize, and secure your account with us.
    </li>
    <li>
      To process your requests, purchases, transactions, and payments and prevent transactional fraud.
    </li>
    <li>
      To provide you with support and to respond to your inquiries, including to investigate and address your concerns and monitor and improve our responses.
    </li>
    <li>
      To personalize your Website experience and to deliver content and product and service offerings relevant to your interests, including targeted offers and ads through our Website, third-party sites, and via email or text message (with your consent, where required by law).
    </li>
    <li>
      To help maintain the safety, security, and integrity of our Website, products and services, databases and other technology assets, and business.
    </li>
    <li>
      For testing, research, analysis, and product development, including to develop and improve our Website, products, and services.
    </li>
    <li>
      To respond to law enforcement requests and as required by applicable law, court order, or governmental regulations.
    </li>
    <li>
      As described to you when collecting your personal information or as otherwise stated in the CCPA.
    </li>
    <li>
      To evaluate or conduct a merger, divestiture, restructuring, reorganization, dissolution, or other sale or transfer of some or all of our assets, whether as a going concern or as part of bankruptcy, liquidation, or similar proceeding, in which personal information held by us about our Website users is among the assets transferred.
    </li>
  </ul>
  <p>
    We will not collect additional categories of personal information or use the personal information we collected for materially different, unrelated, or incompatible purposes without providing you notice.
  </p>
  <h5>
    Sharing Personal Information
  </h5>
  <p>
    We may disclose your personal information to a third party for a business purpose. When we disclose personal information for a business purpose, we enter a contract that describes the purpose and requires the recipient to both keep that personal information confidential and not use it for any purpose except performing the contract.
    <br>
    <br>
    We share your personal information with the following categories of third parties:
  </p>
  <ul>
    <li>
      Service providers.
    </li>
    <li>
      Internet cookie data recipients, like Google Analytics.
    </li>
  </ul>

  <h5>
    Disclosures of Personal Information for a Business Purpose
  </h5>
  <p>
    In the preceding 12 months, Company has disclosed the following categories of personal information for a business purpose:
  </p>
  <ul>
    <li>
      Category A: Identifiers.
    </li>
    <li>
      Category B: California Customer Records personal information categories.
    </li>
    <li>
      Category F: Internet or other similar network activity.
    </li>
  </ul>
  <p>
    We disclose your personal information for a business purpose to the following categories of third parties:
  </p>
  <ul>
    <li>
      Data analytic providers.
    </li>
    <li>
      Service providers.
    </li>
    <li>
      Internet cookie data recipients, like Google Analytics.
    </li>
  </ul>

  <h5>
    Sales of Personal Information
  </h5>
  <p>
    In the preceding 12 months, Company had not sold personal information.
  </p>

  <h5>
    Your Rights and Choices
  </h5>
  <p>
    The CCPA provides consumers (California residents) with specific rights regarding their personal information. This section describes your CCPA rights and explains how to exercise those rights.
    <br>
    <br>
    Access to Specific
    Information and Data Portability Rights
    <br>
    <br>
    You have the right to request that we disclose certain information to you about our collection and use of your personal information over the past 12 months. Once we receive and confirm your verifiable consumer request (see Exercising Access, Data Portability, and Deletion Rights), we will disclose to you:
  </p>
  <ul>
    <li>
      The categories of personal information we collected about you.
    </li>
    <li>
      The categories of sources for the personal information we collected about you.
    </li>
    <li>
      Our business or commercial purpose for collecting or selling that personal information.
    </li>
    <li>
      The categories of third parties with whom we share that personal information.
    </li>
    <li>
      The specific pieces of personal information we collected about you (also called a data portability request).
    </li>
    <li>
      If we sold or disclosed your personal information for a business purpose, two separate lists disclosing:<br>
      sales, identifying the personal information categories that each category of recipient purchased; and disclosures for a business purpose, identifying the personal information categories that each category of recipient obtained.
    </li>
  </ul>

  <h5>
    Deletion Request Rights
  </h5>
  <p>
    You have the right to request that we delete any of your personal information that we collected from you and retained, subject to certain exceptions. Once we receive and confirm your verifiable consumer request (see Exercising Access, Data Portability, and Deletion Rights), we will delete (and direct our service providers to delete) your personal information from our records, unless an exception applies.
    <br>
    <br>
    We may deny your deletion request if retaining the information is necessary for us or our service providers to:
  </p>

  <ul>
    <li>
      Complete the transaction for which we collected the personal information, provide a good or service that you requested, take actions reasonably anticipated within the context of our ongoing business relationship with you, fulfill the terms of a written warranty or product recall conducted in accordance with federal law, or otherwise perform our contract with you.
    </li>
    <li>
      Detect security incidents, protect against malicious, deceptive, fraudulent, or illegal activity, or prosecute those responsible for such activities.
    </li>
    <li>
      Debug products to identify and repair errors that impair existing intended functionality.
    </li>
    <li>
      Exercise free speech, ensure the right of another consumer to exercise their free speech rights, or exercise another right provided for by law.
    </li>
    <li>
      Comply with the California Electronic Communications Privacy Act (Cal. Penal Code 1546 <i>et. seq.</i>).
    </li>
    <li>
      Engage in public or peer-reviewed scientific, historical, or statistical research in the public interest that adheres to all other applicable ethics and privacy laws, when the information's deletion may likely render impossible or seriously impair the research's achievement, if you previously provided informed consent.
    </li>
    <li>
      Enable solely internal uses that are reasonably aligned with consumer expectations based on your relationship with us.
    </li>
    <li>
      Comply with a legal obligation.
    </li>
    <li>
      Make other internal and lawful uses of that information that are compatible with the context in which you provided it.
    </li>
  </ul>

  <h5>
    Exercising Access, Data Portability, and Deletion Rights
  </h5>
  <p>
    To exercise the access, data portability, and deletion rights described above, please submit a verifiable consumer request to us by either:
  </p>
  <ul>
    <li>
      Emailing us at {{ form.companyDetails.supportEmail}}
    </li>
    <li>
      Visiting DOMAIN
    </li>
  </ul>

  <p>
    Only you, or someone legally authorized to act on your behalf, may make a verifiable consumer request related to your personal information. You may also make a verifiable consumer request on behalf of your minor child.
    <br>
    <br>
    You may only make a verifiable consumer request for access or data portability twice within a 12-month period. The verifiable consumer request must:
  </p>
  <ul>
    <li>
      Provide sufficient information that allows us to reasonably verify you are the person about whom we collected personal information or an authorized representative.
    </li>
    <li>
      Describe your request with sufficient detail that allows us to properly understand, evaluate, and respond to it.
    </li>
  </ul>

  <p>
    We cannot respond to your request or provide you with personal information if we cannot verify your identity or authority to make the request and confirm the personal information relates to you.
    <br>
    <br>
    Making a verifiable consumer request does not require you to create an account with us. However, we do consider requests made through your password protected account sufficiently verified when the request relates to personal information associated with that specific account.
    <br>
    <br>
    We will only use personal information provided in a verifiable consumer request to verify the requestor's identity or authority to make the request.
  </p>

  <h5>
    Response Timing and Format
  </h5>
  <p>
    We endeavor to respond to a verifiable consumer request within 45 days of its receipt. If we require more time (up to 45 days), we will inform you of the reason and extension period in writing.
    <br>
    <br>
    If you have an account with us, we will deliver our written response to that account. If you do not have an account with us, we will deliver our written response by mail or electronically, at your option.
    <br>
    <br>
    Any disclosures we provide will only cover the 12-month period preceding the verifiable consumer request's receipt. The response we provide will also explain the reasons we cannot comply with a request, if applicable. For data portability requests, we will select a format to provide your personal information that is readily useable and should allow you to transmit the information from one entity to another entity without hindrance.
    <br>
    <br>
    We do not charge a fee to process or respond to your verifiable consumer request unless it is excessive, repetitive, or manifestly unfounded. If we determine that the request warrants a fee, we will tell you why we made that decision and provide you with a cost estimate before completing your request.
  </p>
  <h5>
    Non-Discrimination
  </h5>
  <p>
    We will not discriminate against you for exercising any of your CCPA rights. Unless permitted by the CCPA, we will not:
  </p>
  <ul>
    <li>
      Deny you goods or services.
    </li>
    <li>
      Charge you different prices or rates for goods or services, including through granting discounts or other benefits, or imposing penalties.
    </li>
    <li>
      Provide you a different level or quality of goods or services.
    </li>
    <li>
      Suggest that you may receive a different price or rate for goods or services or a different level or quality of goods or services.
    </li>
  </ul>
  <p>
    However, we may offer you certain financial incentives permitted by the CCPA that <b>can result </b>in different prices, rates, or quality levels. Any CCPA-permitted financial incentive we offer will reasonably relate to your personal information's value and contain written terms that describe the program's material aspects. Participation in a financial incentive program requires your prior opt in consent, which you may revoke at any time.
  </p>

  <h5>
    Other California Privacy Rights
  </h5>
  <p>
    California's "Shine the Light" law (Civil Code Section 1798.83) permits users of our Website that are California residents to request certain information regarding our disclosure of personal information to third parties for their direct marketing purposes. To make that request, please send an email to {{ form.companyDetails.supportEmail}}.
  </p>

  <h5>
    Changes to Our Privacy Notice
  </h5>
  <p>
    We reserve the right to amend this privacy notice at our discretion and at any time. When we make changes to this privacy notice, we will post the updated notice on the Website and update the notice's effective date. Your continued use of our Website following the posting of changes constitutes your acceptance of such changes
  </p>

  <h5>
    Contact Information
  </h5>
  <p>
    If you have any questions or comments about this notice, the ways in which {{ form.companyDetails.companyName }} collects and uses your information described here and in the privacy policy, your choices and rights regarding that use, or wish to exercise your rights under California law, please do not hesitate to contact us at:

    <span>{{ form.companyDetails.companyName }}</span><br>
    <span class="no-select">{{ form.companyDetails.companyAddress }}</span><br>
    <span>{{ form.companyDetails.supportEmail }}</span><br>
  </p>
</div>
